import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/news/full.vue';
import Detail from '@rebuild/materials/shared/news/detail.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	detail: Detail
};
